const LOCALSTORAGE_KEYS = {
  COLOR_MODE: '@prodez-areadoaluno/color-mode',
  MENU_SHRINKED: '@prodez-areadoaluno/menu-shrinked',
  MOBILE_MENU_OPENED: '@prodez-areadoaluno/mobile-menu-opened',
  TOKEN: '@prodez-areadoaluno/token',
  REMEMBER_ME: '@prodez-areadoaluno/remember-me',
};

export default LOCALSTORAGE_KEYS;
